<template>
  <div id="file-upload">
    <!-- <div>
      <input type="file" @change="onChange" :accept="fileType" />
    </div>
    <div v-if="uploadValue > 0">
      <p>Progress: {{ uploadValue.toFixed() + "%" }}
      <progress id="progress" :value="uploadValue" max="100" ></progress> 
      </p>
    </div>
    <div v-if="picture != null">
      <img class="preview" :src="picture">
    </div> -->

    <div class="file-upload w-100">
      <label class="file-upload-box p-rel" :for="fileId">
        <span class="file-upload-inner" v-if="fileType === 'audio'">
          <span v-if="infoText" class="file-upload-text">{{ infoText }}</span>
          <span class="d-f ai-c g" v-else>
            <IconBase w="15" h="15" viewBox="0 0 15 15" icon-name="music-upload">
              <IconMusic />
            </IconBase>
            <span>Upload Audio</span>
            <span class="file-upload-meta">(Max: {{ calcMaxSize }})</span>
          </span>
        </span>
        <span class="file-upload-inner" v-if="fileType === 'image'">
          <span v-if="infoText" class="file-upload-text">{{ infoText }}</span>
          <span class="d-f ai-c g" v-else>
            <IconBase w="15" h="15" viewBox="0 0 15 15" icon-name="image-upload">
              <IconImg />
            </IconBase>
            <span>Upload Image</span>
            <span class="file-upload-meta">(Max: {{ calcMaxSize }})</span>
          </span>
        </span>
        <span
          class="progress-bar transition-width"
          :class="{ completed: progressWidth === 0 }"
          :style="{ width: progressWidth + '%' }"
        ></span>
      </label>
      <input
        v-if="fileType === 'audio'"
        type="file"
        :id="fileId"
        @change="onChange"
        accept="audio/*"
      />
      <input
        v-if="fileType === 'image'"
        type="file"
        :id="fileId"
        @change="onChange"
        accept="image/*"
      />
    </div>
    <div class="file-name d-f fd-c jc-c ai-c" v-if="data != null">
      <p class="p" v-if="uploadValue">
        Uploading: {{ uploadValue.toFixed() + "%" }}
      </p>
    </div>
    <ImageCropper
      :src="croppingImgFile"
      @save="imageCropped"
      @cancel="imageCropCanceled"
    />
  </div>
</template>

<script>
import {
  blobToFile,
  dataURLtoBlob,
  formatBytes,
  getFileBaseName,
  mbToBytes,
} from "@/common";
import { compressAudioFile } from "@/services/audioCompressionService";
import ImageCropper from "@/components/misc/ImageCropper.vue";
import IconMusic from "@/assets/icons/IconMusic.vue";
import IconBase from "@/assets/icons/IconBase.vue";
import IconImg from "@/assets/icons/IconImg.vue";

export default {
  name: "FileUpload",
  components: { ImageCropper, IconMusic, IconBase, IconImg },
  props: ["fileType", "fileId", "minSize", "maxSize", "uploadValue"],
  data() {
    return {
      data: null,
      dataSize: null,
      picture: null,
      processingValue: -1,
      croppingImgFile: null,
      _audioCompressionTask: null,
      _activeCompressionRunId: 0,
      _activeCompressionReject: null,
    };
  },
  beforeDestroy() {
    this.cancelActiveCompression();
  },
  computed: {
    calcMaxSize() {
      return formatBytes(this.maxSize);
    },
    progressWidth() {
      return this.processingValue >= 0
        ? this.processingValue
        : this.uploadValue;
    },
    infoText() {
      if (!this.data) return;

      if (this.processingValue >= 0) {
        return `Processing [${this.processingValue}%] ${this.data.name}`;
      } else {
        return [this.data.name, this.dataSize].filter(Boolean).join(", ");
      }
    },
  },
  methods: {
    cancelActiveCompression() {
      if (this._audioCompressionTask) {
        this._audioCompressionTask.cancel();
        this._audioCompressionTask = null;
      }
      if (this._activeCompressionReject) {
        this._activeCompressionReject({ isCancelled: true });
        this._activeCompressionReject = null;
      }
      this._activeCompressionRunId += 1;
    },
    onChange(event) {
      this.cancelActiveCompression();
      this.uploadValue = 0;
      this.processingValue = -1;
      this.data = null;
      this.dataSize = null;
      this.$emit("fileData", null);

      // this.picture = null
      // this.data = event.target.files[0]

      const file = event.target.files[0];
      const size = file?.size;
      event.target.value = "";
      if (size > this.minSize && size < this.maxSize) {
        console.log("File OK");
        this.data = file;

        if (this.fileType === "audio") {
          this.dataSize = formatBytes(size);

          if (size > mbToBytes(5)) {
            this.processAudio(file)
              .then((newFile) => {
                this.data = newFile;
                this.dataSize = formatBytes(newFile.size);
                this.$emit("fileData", newFile);
              })
              .catch((e) => {
                if (e && e.isCancelled) return;
                console.error(e);
                this.data = null;
                this.dataSize = null;
                alert("Failed to process file");
              });
          } else {
            this.$emit("fileData", file);
          }
        } else if (this.fileType === "image") {
          this.croppingImgFile = file;
        }
      } else {
        //file too big or small
        this.$emit("fileData", null);
        alert("Wrong filesize");
      }
    },
    async processAudio(file) {
      return new Promise((resolve, reject) => {
        if (this.fileType !== "audio") {
          resolve(file);
          return;
        }
        this._activeCompressionRunId += 1;
        const runId = this._activeCompressionRunId;
        this._activeCompressionReject = reject;

        this._audioCompressionTask = compressAudioFile(file, {
          onProgress: (progress) => {
            if (runId !== this._activeCompressionRunId) return;
            this.processingValue = progress;
          },
          onComplete: (blob) => {
            if (runId !== this._activeCompressionRunId) return;
            this._audioCompressionTask = null;
            this._activeCompressionReject = null;
            const newFile = blobToFile(
              blob,
              getFileBaseName(file.name) + ".mp3"
            );
            this.processingValue = -1;
            resolve(newFile);
          },
          onError: (e) => {
            if (runId !== this._activeCompressionRunId) return;
            this._audioCompressionTask = null;
            this._activeCompressionReject = null;
            this.processingValue = -1;
            reject(e);
          },
        });
      });
    },
    imageCropped(dataURL) {
      const blob = dataURLtoBlob(dataURL);

      const file = blobToFile(blob, getFileBaseName(this.data.name) + ".jpeg");
      this.$emit("fileData", file);
      this.croppingImgFile = null;

      this.data = file;
      this.dataSize = formatBytes(file.size);
    },
    imageCropCanceled() {
      this.$emit("fileData", null);
      this.croppingImgFile = null;
      this.data = null;
      this.dataSize = null;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/scss/_variables.scss";

/* Match input-container / GenreSelect box height (same as other input fields) */
.file-upload-box {
  display: flex;
  align-items: center;
  padding: $mg-desktop-md;
  gap: $mg-desktop;
  flex-wrap: wrap;
  border: $border-small solid $line-color;
  border-radius: $border-radius-input;
  font-size: $p1;
  color: $text-color;
  background-color: $brand-bg;
  cursor: pointer;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
  min-height: 0; /* height from padding + content, like input fields */

  &:hover {
    border-color: $brand-hl !important;
  }

  .file-upload-meta {
    opacity: 0.5;
    font-size: 0.875em;
  }

  .file-upload-text {
    flex: 1;
    min-width: 0;
  }
}

.progress-bar {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background-color: white;
  opacity: 0.2;
  pointer-events: none;
}
</style>
